var youbora = require('youboralib')
require('./adapter')

module.exports = youbora



//////////////////
// WEBPACK FOOTER
// ./src/sp.js
// module id = 53
// module chunks = 0